"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _icons = _interopRequireDefault(require("../../images/icons"));

var ICON_LIST = {
  RECENT_SEARCH: {
    web: "https://a.staticaa.com/images/web-apps/component/flight-search/ic_recent.svg",
    mobile: _icons["default"].recentSearches
  },
  NEAREST_AIRPORT: {
    web: "https://a.staticaa.com/images/web-apps/component/flight-search/ic_location.svg",
    mobile: _icons["default"].nearestAirport
  },
  FLIGHT_ICON: {
    web: "https://a.staticaa.com/images/web-apps/component/flight-search/ic_flight.svg ",
    mobile: _icons["default"].flightIcon
  },
  FLIGHT_ICON_BLUE: {
    web: "https://a.staticaa.com/images/web-apps/component/flight-search/ic_flight_blue.svg",
    mobile: _icons["default"].flightIconBlue
  },
  CITY_TRANSFER: {
    web: "https://a.staticaa.com/images/web-apps/component/flight-search/ic_citytransfer.svg",
    mobile: _icons["default"].cityTransfer
  },
  ISLAND_TRANSFER: {
    web: "https://a.staticaa.com/images/web-apps/component/flight-search/ic_islandtransfer.svg",
    mobile: _icons["default"].islandTransfer
  },
  OTHER_AIRLINES: {
    web: "https://a.staticaa.com/images/web-apps/component/flight-search/ic_exlink_blue.svg",
    mobile: _icons["default"].otherAirlines
  },
  SWAP_ICON: {
    web: "https://storage.googleapis.com/aaicons/ic_switch.svg",
    mobile: _icons["default"].swapIcon
  },
  CLOSE_ICON: {
    web: "https://storage.googleapis.com/aaicons/ic_close.svg",
    mobile: _icons["default"].closeIcon
  },
  CHECK_ICON: {
    web: "https://storage.googleapis.com/hotel-icons/ic_check.svg",
    mobile: _icons["default"].checkIcon
  },
  ARROW_LEFT: {
    web: "https://storage.googleapis.com/aaicons/ic_arrow_left.svg",
    mobile: _icons["default"].arrowLeftIcon
  },
  ARROW_RIGHT: {
    web: "https://storage.googleapis.com/aaicons/ic_arrow_right.svg",
    mobile: _icons["default"].arrowRightIcon
  },
  ARROW_RIGHT_WHITE: {
    web: "https://storage.googleapis.com/aaicons/ic_arrow_right_white.svg",
    mobile: _icons["default"].arrowRightIconWhite
  },
  ARROW_DROPDOWN: {
    web: "https://storage.googleapis.com/aaicons/ic_drop_down.svg",
    mobile: _icons["default"].arrowDropdown
  },
  LOCATION: {
    web: "https://a.staticaa.com/images/web-apps/component/flight-search/ic_location.svg",
    mobile: _icons["default"].location
  },
  CALENDAR: {
    web: "https://storage.googleapis.com/aaicons/ic_calendar.svg",
    mobile: _icons["default"].calendar
  },
  WARNING_ICON: {
    web: "https://storage.googleapis.com/aaicons/error_outline_24px.svg",
    mobile: _icons["default"].warningIcon
  },
  AIRPORT: {
    web: "https://storage.googleapis.com/hotel-icons/ic_airport.svg",
    mobile: _icons["default"].airportIcon
  },
  POI: {
    web: "https://storage.googleapis.com/hotel-icons/ic_poi.svg",
    mobile: _icons["default"].poiIcon
  },
  NAV_BACK_WHITE_ICON: {
    web: "https://storage.googleapis.com/hotel-icons/ic_nav_back_white.svg",
    mobile: _icons["default"].navBackWhiteIcon
  },
  NO_RESULTS: {
    web: "https://storage.googleapis.com/hotel-icons/ic_no_results.png",
    mobile: _icons["default"].noResultsIcon
  },
  EXPAND_MORE: {
    web: "https://storage.googleapis.com/hotel-icons/ic_expand_more.svg",
    mobile: _icons["default"].expandMore
  }
};
var _default = ICON_LIST;
exports["default"] = _default;